import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import SuggestedFilterToken from 'Components/AdvisorApp/Header/ClientSearchBar/BetaSearchBar/SuggestedFilterToken';
import {
  getSuggestedFilterOptionDOMId,
  onSelectSearchType,
  useSearchBarDispatch,
  useSearchBarState,
} from 'Components/AdvisorApp/Header/ClientSearchBar/BetaSearchBar/SearchBarContext';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';

const styles = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    borderRadius: theme.radius.sm,
    color: theme.palette.facet.darkGray,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  rootSelected: {
    backgroundColor: theme.palette.facet.accentBlue2,
  },
  left: {
    flexShrink: 0,
    marginRight: theme.spacing(1),
  },
  right: {
    flexGrow: 1,
    pointerEvents: 'none',
    userSelect: 'none',
  },
});

const SuggestedFilter = ({
  className,
  classes,
  id,
  isSelected,
  prompt,
}) => {
  const eventTracking = useEventTrackingLogEvent();
  const searchBarDispatch = useSearchBarDispatch();
  const searchBarState = useSearchBarState();
  const domId = getSuggestedFilterOptionDOMId(id);

  return (
    <Box
      className={classNames(classes.root, className, {
        [classes.rootSelected]: isSelected,
      })}
      id={domId}
      onMouseEnter={() => {
        searchBarDispatch({ type: 'setSelectionDOMId', selectionDOMId: domId });
      }}
      onMouseLeave={() => {
        searchBarDispatch({ type: 'setSelectionDOMId', selectionDOMId: null });
      }}
      onClick={() => {
        document.getElementById('global-search-input').focus();
        eventTracking.logEvent('search > select search type', {
          searchType: id,
        });
        onSelectSearchType(searchBarDispatch, searchBarState, id)();
      }}
    >
      <SuggestedFilterToken
        className={classes.left}
        text={id}
      />
      <Typography
        className={classes.right}
        color={(isSelected) ? 'white' : 'primaryGray'}
        weight={'book'}
        variant={'h5'}
      >
        {prompt}
      </Typography>
    </Box>
  );
};

SuggestedFilter.defaultProps = {
  className: '',
};

SuggestedFilter.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  prompt: PropTypes.string.isRequired,
};

export default withStyles(styles)(SuggestedFilter);
